module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3TA7o9/tc-custom/9781466828674.jpg?1737749687993",
      "alt": "This image is the cover for the book The Sam Gunn Omnibus"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Sam Gunn Omnibus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("THE IRREPRESSIBLE SAM GUNN"), _c('br'), _c('br'), _vm._v("A hero without peer or scruples, Sam Gunn has a nose for trouble, money, and women—though not necessarily in that order.  A man with the ego (and stature) of a Napoleon, the business acumen of a P. T. Barnum, and the raging hormones of a teenage boy, Sam is the finest astronaut NASA ever trained…and dumped. "), _c('br'), _c('br'), _vm._v("But more than money, more than women, Sam Gunn loves justice.  (And he really "), _c('i', [_vm._v("does")]), _vm._v(" love money and women.)  Whether he's suing the Pope, helping twin sisters entangled in the \"virtual sex\" trade, or on trial for his life on charges of interplanetary genocide, you can be sure of one thing: this is one space jockey who'll meet every challenge with a smile on his lips, an ace up his sleeve…and a weapon in his pocket."), _c('br'), _c('br'), _vm._v("Now, for the first time between covers, Hugo-winner Ben Bova presents all the tales of Sam Gunn to date, including three never before collected in book form.  Here is the entire chronicle of Sam Gunn, trailblazer and scoundrel, as he scams his way from one end of the Solar System to the other, giving bold new meaning to the term \"venture capitalist.\""), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ben Bova\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0